'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = exports.Table = undefined;

var _components = require('./components');

Object.defineProperty(exports, 'Table', {
  enumerable: true,
  get: function get() {
    return _components.Table;
  }
});
Object.defineProperty(exports, 'Cell', {
  enumerable: true,
  get: function get() {
    return _components.Cell;
  }
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('jdm.material', []).directive('mdGrow', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      attrs.$observe('mdGrow', function (grow) {
        element.css({ flex: grow });
      });
    }
  };
}).directive('mdTable', function () {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<md-content class="md-table" ng-transclude></md-content>'
  };
}).directive('mdTableHeader', function ($mdTheming, $compile, $mdSticky) {
  return {
    restrict: 'E',
    template: '<md-table-row class="md-table-header"></md-table-row>',
    transclude: true,
    replace: true,
    compile: function compile(element, attr, transclude) {
      return function postLink(scope, element, attrs) {
        $mdTheming(element);
        var outerHTML = element[0].outerHTML;

        transclude(scope, function (clone) {
          element.append(clone);
        });

        if (!element.hasClass('md-no-sticky')) {
          transclude(scope, function (clone) {
            var stickyClone = $compile(angular.element(outerHTML))(scope);
            stickyClone.append(clone);
            $mdSticky(scope, element, stickyClone);
          });
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./table/index.js
// module id = 134
// module chunks = 0